<script lang="ts" setup>
const documentId = inject("documentId") as any;
const documentParagraphsStore = useDocumentParagraphsStore(documentId);
const { isFixingAssignment, hasSelectedParagraphToInsert } = storeToRefs(
  documentParagraphsStore
);

const containerRef = ref();

const windowWidthStore = useWindowWidth();
const { windowWidth } = storeToRefs(windowWidthStore);

const left = computed(() => {
  const documentElement = document.getElementById("document-container");

  if (!documentElement) return 0;

  const documentRect = documentElement.getBoundingClientRect();

  if (!documentRect) return 0;

  const center = documentRect.width / 2;

  const containerElement = containerRef.value as HTMLElement | undefined;

  if (!containerElement) return center;

  const containerRect = containerElement.getBoundingClientRect();

  if (!containerRect) return center;

  return (
    documentRect.left + center - containerRect.width / 2 - windowWidth.value * 0
  );
});

const isFixing = ref(false);

const fixAssignment = async () => {
  isFixing.value = true;
  await documentParagraphsStore.fixAssignment();
  useDocumentChecklistStore(documentId).reevaluateAllCriteria();

  isFixing.value = false;
};
</script>

<template>
  <TransitionsFade>
    <div
      v-if="isFixingAssignment"
      ref="containerRef"
      class="rounded bg-surface shadow p-4 fixed bottom-4 max-w-[500px]"
      :style="{
        left: left + 'px',
      }"
    >
      <div class="mb-2">
        Click the line that appears at the top of the student's assignment.
        Usually this is the student's name located above the date and title.
        Select Fix Assignment.
      </div>
      <BaseButton
        :disabled="hasSelectedParagraphToInsert != true"
        @click="fixAssignment"
        :show-spinner="isFixing"
      >
        Fix Assignment
      </BaseButton>
      <BaseTextButton
        @click="documentParagraphsStore.toggleIsFixingAssignment(false)"
        color="danger"
      >
        cancel
      </BaseTextButton>
    </div>
  </TransitionsFade>
</template>

<style scoped></style>
